
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/banking/simulator",
      function () {
        return require("private-next-pages/banking/simulator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/banking/simulator"])
      });
    }
  